/* eslint-disable eqeqeq */
/* eslint-disable no-self-assign */
import axios from 'axios'
import router from '@/router'
import { Toast } from 'vant'
axios.defaults.timeout = 10000
axios.defaults.baseURL = ''

axios.interceptors.request.use(
  config => {
    let token = null
    var query = window.location.hash.substring(1).split('?')[1]

    if (query) {
      var vars = query.split('&')
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=')
        if (pair[0] == 'token') {
          token = pair[1].replace(/%20/g, ' ')
        }
      }
    }
    config.data = config.data
    if (token) {
      config.headers = {
        'content-type': 'application/json',
        'Access-Control-Expose-Headers': 'Authorization',
        Authorization: token
      }
    } else {
      config.headers = { 'Content-Type': 'application/x-www-form-urlencoded' }
    }

    /* if (config.url === '/api/login/index') {
    } else {
      if (localStorage.getItem('Authorization')) {
        config.headers.Authorizatior = localStorage.getItem('Authorization')
      }
    } */
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// 响应拦截器即异常处理
axios.interceptors.response.use(response => {
  if (response.data.status == 401) {
    router.push({
      path: '/'
    })
  }
  return response
}, err => {
  // console.log('---- err', err)
  if (err && err.response) {
    Toast.fail(err.response.data.resp_msg)
    switch (err.response.status) {
      case 400:
        console.log('错误请求')
        break
      case 401:
        console.log('未授权，请重新登录')
        router.push({
          path: '/'
        })
        break
      case 403:
        console.log('拒绝访问')
        break
      case 404:
        console.log('请求错误,未找到该资源')
        break
      case 405:
        console.log('请求方法未允许')
        break
      case 408:
        console.log('请求超时')
        break
      case 500:
        console.log('服务器端出错')
        break
      case 501:
        console.log('网络未实现')
        break
      case 502:
        console.log('网络错误')
        break
      case 503:
        console.log('服务不可用')
        break
      case 504:
        console.log('网络超时')
        break
      case 505:
        console.log('http版本不支持该请求')
        break
      default:
        console.log(`连接错误${err.response.status}`)
    }
  } else {
    Toast.fail('请求超时,请检查网络')
  }
  return Promise.resolve(err.response)
})

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch (url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(this.$common.urlFName + url, {
      params: params
    }).then(response => {
      resolve(response.data)
    }).catch(err => {
      reject(err)
    })
  })
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(this.$common.urlFName + url, data).then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    })
  })
}
/**
 * 封装get请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get (url, data) {
  return new Promise((resolve, reject) => {
    axios.get(this.$common.urlFName + url + data).then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    })
  })
}
/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function del (url, data) {
  return new Promise((resolve, reject) => {
    axios.delete(this.$common.urlFName + url + data).then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    })
  })
}
/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
  })
}
/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        resolve(response.data)
      }, err => {
        reject(err)
      })
  })
}

// 对图片进行压缩
export function compressImg (img, callback) {
  var data
  // 新建一个img标签
  var image = new Image()
  image.src = img
  let imageWidth = ''
  let imageHeight = ''
  image.onload = function () {
    imageWidth = image.width * 0.8
    imageHeight = image.height * 0.8
    var canvas = document.createElement('canvas')
    var context = canvas.getContext('2d')
    // 压缩后图片的大小
    canvas.width = imageWidth
    canvas.height = imageHeight
    context.drawImage(image, 0, 0, imageWidth, imageHeight)
    data = canvas.toDataURL('image/jpeg').replace('data:image/jpeg;base64,', '')
    var length = data.toString().length
    if (length > 1024 * 200) {
      // console.log('图片过大')
      compressImg(data, callback)
    }
    callback(data)
  }
}

export function getPic (picurl, callback) {
  const imgTools = require('../utils/imgTools')
  var file = picurl
  var reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = function (e) {
    var image = imgTools.showImg(e.target.result)
    setTimeout(() => {
      imgTools.compressImg(image)
      // 获取角度1 6 3 8
      const orientation = imgTools.getOrientation(
        imgTools.base64ToArrayBuffer(e.target.result)
      )

      const canvas = document.createElement('canvas')
      let canvasWidth = image.width // 图片原始长宽
      let canvasHeight = image.height
      const base = canvasWidth / canvasHeight
      if (canvasWidth > 700) {
        canvasWidth = 700
        canvasHeight = Math.floor(canvasWidth / base)
      }
      canvas.width = canvasWidth
      canvas.height = canvasHeight
      var baseStr
      switch (orientation) {
        case 6: // 需要顺时针（向左）90度旋转
          // console.log('（向左）90度旋转')
          baseStr = imgTools.rotateImg(image, 'left', canvas)
          break
        case 8: // 需要逆时针（向右）90度旋转
          // console.log('（向右）90度旋转')
          baseStr = imgTools.rotateImg(image, 'right', canvas)
          break

        case 3: // 需要180度旋转 转两次
          // console.log('需要180度旋转')
          baseStr = imgTools.rotateImg(image, 'right', canvas, 2)
          break
        default:
          baseStr = imgTools.rotateImg(image, '', canvas)
          break
      }
      callback(baseStr)
    }, 1000)
  }
}

export function GetQueryString (name) {
  var query = window.location.search.substring(1)
  var vars = query.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] == name) {
      return pair[1].replace(/%20/, ' ')
    }
  }
}
